<template>
<div id='addressCreate'>

	<div v-if='adc_show !== 0' :class="{'ade-mask':true, 'ade-mask-close':adc_show === 2}" @click='vadc_close'></div>
	<div :class="{'ade-model':true, 'ade-model-show':adc_show===1}">
		<!-- 视觉区域 -->
		<div class='ade-model-visual' @click='vadc_close'>
			<!-- 绳索 -->
			<div v-for='item in 4' :key='item' class='ade-model-visual-layout'>
				<div class='ade-model-visual-layo-view01'><div v-for='item in 2' :key='item' class='ade-model-visual-layo-view01-line'></div></div>
				<div class='ade-model-visual-layo-view02'></div>
			</div>
			<div class='ade-model-visual-layout2'></div>
		</div>
		<!-- 面板 -->
		<div class='ade-model-plate'>
			<!-- 面板-首行 -->
			<div class='ade-model-plate-title no-copy'>
				<div class='fontcolor-16 fontweight-bo'>新增地址</div>
				<div class='ade-model-plate-tit-right'>
					<div class='ade-model-plate-tit-rig-btn font-12 bgcolor' @click='vadc_save'>保存</div>
					<div class='ade-model-plate-tit-rig-btn ade-model-plate-tit-rig-btn-no font-12'
						 @click='vadc_closes'>取消
					</div>
				</div>
			</div>
			<div v-for='item in adc_list' :key='item.id' class='ade-model-plate-line font-14'>
				<div :class="{'ade-model-plate-line-name':true, 'color-prompt':!item.canModify}">{{item.name}}</div>
				<v-distpicker v-if="item.value.constructor['name']==='Array'" 
							  wrapper='ade-model-plate-line-picker' 
							  :province="adc_list[3]['value'][0]" 
							  :city="adc_list[3]['value'][1]" 
							  :area="adc_list[3]['value'][2]" 
							  @selected='func_distpicker' 
							  >
				</v-distpicker>
				<input v-else-if='item.canModify' class='ade-model-plate-line-input' :placeholder='item.prompt' v-model='item.value' />
				<div v-else class='ade-model-plate-line-onlineShow color-prompt'>{{item.value}}</div>
			</div>
			<div class='ade-model-plate-line font-14'>
				<div class='ade-model-plate-line-name'>快捷输入</div>
				<input class='ade-model-plate-line-input' placeholder='可选-粘贴地址 [省市区详细地址 联系号码 联系人]' v-model='fastString' @input='fastChange' />
			</div>
		</div>
	</div>

</div>
</template>
<script>
export default {
	name: 'addressCreate',
	props: {},
	data() {
		return {
			adc_show: 0,
			adc_list: [
				{id:'adel01', canModify:true,  name:'联系人',   value:'', prompt:''},
				{id:'adel02', canModify:true,  name:'联系电话', value:'', prompt:''},
				{id:'adel03', canModify:true,  name:'收货公司', value:'', prompt:''},
				{id:'adel06', canModify:true,  name:'收货地区', value:['', '', ''], prompt:''},
				{id:'adel04', canModify:true,  name:'收货地址', value:'', prompt:'详细地址'},
				// {id:'adel05', canModify:false, name:'是否默认', value:'否'},
      ],
			temp_index: -1,
			fastString: '',
		}
	},
	methods: {
		// show方法
		vadc_Change(index) {
      this.temp_index = index;
			this.adc_show = 1;
		},
		vadc_closes() {
			this.vadc_close();
			if (this.$parent['func_createAddressCancel']) this.$parent.func_createAddressCancel();
		},
		// close方法
		vadc_close() {
			this.adc_show = 2;
			setTimeout(() => {
				this.adc_show = 0;
			}, 200)
		},
		// 地区选择触发器
		func_distpicker(event) {
			this.adc_list[3]['value'] = [
				event['province']['code'] ? event['province']['value'] : '',
				event['city']['code'] ? event['city']['value'] : '',
				event['area']['code'] ? event['area']['value'] : '',
			];
		},
		// 保存
		vadc_save() {

			for (let i in this.adc_list) {
				if (this.adc_list[i]['id']!=='adel06' && (!this.adc_list[i]['value'] || this.adc_list[i]['value'].length < 1)) {
					this.$parent.$parent.msgChange('warning', '请填写'+this.adc_list[i]['name'], '');
					return;
				} else if (this.adc_list[i]['id'] === 'adel06') {
					for (let j in this.adc_list[i]['value']) {
						if (!this.adc_list[i]['value'][j] || this.adc_list[i]['value'][j].length < 1) {
							this.$parent.$parent.msgChange('warning', '请补充完整地区', '');
							return;
						}
					}
				}
			}

			this.$parent.func_createAddress({
				Address: this.adc_list[4]['value'],
				Attn: this.adc_list[0]['value'],
				Company: this.adc_list[2]['value'],
				Mobile: this.adc_list[1]['value'],
				province: this.adc_list[3]['value'][0],
				city: this.adc_list[3]['value'][1],
				area: this.adc_list[3]['value'][2],
			}, this.temp_index);
			this.vadc_close();
			// this.$parent.func_editorAddress(temp);
			// this.vadc_close();
		},
		fastChange(event) {
			if (event.data) {
				const json = this.smartParse(event.data);
				this.adc_list[0].value = json.name ? json.name : '';
				this.adc_list[1].value = json.phone ? json.phone : '';
				this.adc_list[3].value = [json.province ? json.province : '', json.city ? json.city : '', json.county ? json.county : ''];
				this.adc_list[4].value = json.address ? json.address : '';
			}
		}
	}
}
</script>
<style scoped>
#addressCreate {
}
.ade-mask {
	background:rgba(0, 0, 0, 0);
	width:100%; height:100vh;
	position:fixed; top:0; left:0;
  animation: adeMaskShow 0.2s linear 0s forwards;
  z-index:210;
}
@keyframes adeMaskShow
{
	from {background:rgba(0, 0, 0, 0);}
	to {background:rgba(0, 0, 0, 0.5);}
}
.ade-mask-close {
	animation: adeMaskClose 0.2s linear 0s forwards;
}
@keyframes adeMaskClose
{
	from {background:rgba(0, 0, 0, 0.5);}
	to {background:rgba(0, 0, 0, 0);}
}

.ade-model {
	display:flex; flex-direction:column; align-items:center;
	position:fixed; top:0; left:calc((100% - 500px)/2);
	transform: translateY(-102%);
  transition: all 0.5s ease-in-out 0s;
  z-index:210;
}
.ade-model-show {
	transform: translateY(-0%);
}

.ade-model-visual {
	height:200px;
	overflow:hidden;
}
.ade-model-visual-layout {
display:flex; flex-direction:column; align-items:center;
}
.ade-model-visual-layo-view01 {
	width:20px; height:26px;
	display:inline-flex; justify-content:space-between; align-items:center;
}
.ade-model-visual-layo-view01-line {
	background:rgba(255, 255, 255, 0.9);
	width:6px; height:100%;
	border-radius:10px;
}
.ade-model-visual-layo-view02 {
	background:rgba(255, 255, 255, 0.9);
	width:6px; height:20px;
	border-radius:10px;
}
.ade-model-visual-layout2 {
	background:rgba(255, 255, 255, 1);
	width:160px; height:16px;
	transform: scaleY(1.3) perspective(.4em) rotateX(5deg);
	transform-origin: bottom;
}

.ade-model-plate {
	background:rgba(255, 255, 255, 1);
	width:500px;
	box-sizing:border-box; padding:0 20px 20px 20px;
	border-radius:10px;
	box-shadow:0 0 4px #aaaaaa;
}
.ade-model-plate-title {
	width:100%;
	padding:16px 0;
	display:flex; flex-wrap:wrap; justify-content:space-between;
}
.ade-model-plate-tit-right {
	display:inline-flex; flex-wrap:wrap; align-items:center;
}
.ade-model-plate-tit-rig-btn {
	color:#ffffff; margin:0 0 0 4px;
	box-sizing:border-box; padding:4px 10px;
	border-radius:4px; border:1px solid #eeeeee;
	cursor:pointer;
}
.ade-model-plate-tit-rig-btn:active {
	opacity:0.8;
}
.ade-model-plate-tit-rig-btn-no {
	background:#aaaaaa;
}
.ade-model-plate-line {
	width:100%; margin:10px 0;
	display:flex; align-items:center;
}
.ade-model-plate-line-name {
	width:76px;
}
.ade-model-plate-line-input {
	width:calc(100% - 76px); height:26px;
	border-radius:0; border-width:0 0 1px 0; border-style:solid; border-color:#cccccc;
}
.ade-model-plate-line-onlineShow {
	width:calc(100% - 76px); height:26px;
	display:inline-flex; align-items:center;
	box-sizing:border-box; padding:0 11px;
}
.ade-model-plate-line-picker {
	width:calc(100% - 76px); height:26px;
	box-sizing:border-box; padding-left:11px;
	border-width:0 0 1px 0; border-style:solid; border-color:#cccccc;
}
</style>




// WEBPACK FOOTER //
// src/components/address/addressCreate.vue